import comp from "./StandardTable";
export default comp;
